/**
 * Author bio toggle
 *
 * @return {void}
 */
const init = () => {
	const authorBioToggle = document.querySelector( '.js-author-bio-toggle' );

	if ( !authorBioToggle ) {
		return;
	}

	const authorBioContainerId = authorBioToggle.getAttribute( 'aria-controls' );
	const authorBioContainer = document.getElementById( authorBioContainerId );

	if ( authorBioContainer ) {
		authorBioContainer.setAttribute( 'aria-hidden', 'true' );
		authorBioToggle.setAttribute( 'aria-expanded', 'false' );
	}

	authorBioToggle.addEventListener( 'click', ( e ) => {
		e.preventDefault();

		if ( authorBioContainer ) {

			const isHidden = authorBioContainer.getAttribute( 'aria-hidden' ) !== 'false';

			if ( isHidden ) {
				authorBioContainer.setAttribute( 'aria-hidden', 'false' );
				authorBioToggle.setAttribute( 'aria-expanded', 'true' );
			} else {
				authorBioContainer.setAttribute( 'aria-hidden', 'true' );
				authorBioToggle.setAttribute( 'aria-expanded', 'false' );
			}
		}
	} );
};

export default { init };


